import * as Config from '../../../config';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { MenuItem } from "react-contextmenu";
import { showMenu } from 'react-contextmenu/modules/actions';
import { debounce } from "throttle-debounce";
import '../common/Search.css';

import { setContextMenu } from "../../../actions/index";
import { setStateShortcuts } from "../shortcut/redux/actions/index";

import useTooltip from '../tooltip/hooks/useTooltip';
import useKeyPress from '../../../hooks/useKeyPress';

import ChevronActive from '../svg/ChevronActive';
import ChevronInactive from '../svg/ChevronInactive';
import IconSearch from './svg/IconSearch';
import IconClear from './svg/IconClear';
import IconSelected from './svg/IconSelected';

let lockDebounce = false;
function ConnectedSearchAdvanced({
  placeholder, className, style,
  setContextMenu, api, storeRoute, setStateShortcuts
}) {

  const [value, setValue] = useState('');
  const [type, setType] = useState(`Artists`);
  const [lock, setLock] = useState(false);
  const [focus, setFocus] = useState(false);
  const prepareFocus = () => {
    setFocus(true);
    setStateShortcuts(false);
  }
  const prepareBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget) && !lock) {
      setFocus(false);
      setStateShortcuts(true);
    }
    setLock(false);
  }
  const el = useRef();
  const elInput = useRef();
  const onEnterPress = (e) => {
    if (e.charCode === 13 && value) {
      lockDebounce = true;
      searchAction(value);

      elInput.current.blur();
    }
  }
  const searchAction = (value) => {
    const link = `/search/${type.toLowerCase()}/${value ? encodeURIComponent(value.replaceAll(` `, `+`)) : ``}`;
    (storeRoute && storeRoute.goTo) && storeRoute.goTo(link);
  }
  const prepareSearchAction = (value) => () => {
    setValue(value);
    searchAction(value);
  }

  const debouncedApply = useCallback(debounce(1000, (v) => {
    const searchType = (type.toLowerCase() === 'playlists') ? `charts` : type.toLowerCase();
    api.getFromApi(`/catalog/search/?type=${searchType}&q=${v}&per_page=5`, false).then( response => {
      const samples = response.data[searchType].map( (x,i) =>
        <MenuItem key={`s-${searchType}-${i}`} onClick={prepareSearchAction(x.name)} data={{ action: 'Sample' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconSearch size={16} />
            {x.name}
          </div>
        </MenuItem>
      );
      if (!lockDebounce) {
        setContextMenu(samples, {className: 'dynamic-menu-search-recommand'});
        const p = el.current.getBoundingClientRect();
        showMenu({ position: {x: p.left + 100, y: p.top + p.height}, target: {}, id: `DynamicMenu` })
      }

    } ).catch( e => console.log(`error`, e) );

  }), [lock, type])
  const onChange = (e) => {
    lockDebounce = false;
    setValue(e.target.value);
    if (e.target.value.length > 0) {
      debouncedApply(e.target.value);
    }
  }

  const clear = () => {
    setValue(``);
    elInput.current.focus();
  }
  const clickType = (type) => () => {
    setType(type);
    setLock(false);
    elInput.current.focus();
  };
  const showContextMenu =  () => {
    if (lock) {
      elInput.current.focus();
    } else {
      setLock(true);
      lockDebounce = true;
      setContextMenu([
        <MenuItem key={`Artists`} onClick={clickType(`Artists`)} data={{ action: 'Artists' }}>
          <div className={'flexRow space-between block-contextmenu-item all-hover'}>
            {`Artists`}
            {type === 'Artists' ? <IconSelected size={18} /> : <IconSearch size={16} className={'hidden'} />}
          </div>
        </MenuItem>,
        <MenuItem key={`Tracks`} onClick={clickType(`Tracks`)} data={{ action: 'Tracks' }}>
          <div className={'flexRow space-between block-contextmenu-item all-hover'}>
            {`Tracks`}
            {type === 'Tracks' ? <IconSelected size={18} /> : <IconSearch size={16} className={'hidden'} />}
          </div>
        </MenuItem>,
        <MenuItem key={`Labels`} onClick={clickType(`Labels`)} data={{ action: 'Labels' }}>
          <div className={'flexRow space-between block-contextmenu-item all-hover'}>
            {`Labels`}
            {type === 'Labels' ? <IconSelected size={18} /> : <IconSearch size={16} className={'hidden'} />}
          </div>
        </MenuItem>,
        <MenuItem key={`Playlists`} onClick={clickType(`Playlists`)} data={{ action: 'Playlists' }}>
          <div className={'flexRow space-between block-contextmenu-item all-hover'}>
            {`Playlists`}
            {type === 'Playlists' ? <IconSelected size={18} /> : <IconSearch size={16} className={'hidden'} />}
          </div>
        </MenuItem>
      ], {className: 'dynamic-menu-search-compact'});
      const p = el.current.getBoundingClientRect();
      showMenu({
        position: {x: p.left + /*176*/ 102, y: p.top + p.height},
        target: {},
        id: `DynamicMenu`
      })
    }
  }

  const keyControlF = useKeyPress('f', true, true, true);
  useEffect(() => {
    if (keyControlF) {
      setTimeout(() => { elInput.current.focus() }, 100);
    }
  }, [keyControlF, elInput])

  useTooltip(`ref-search`, `Search`, `Search by artist, label, track or playlist`);

  const forceFocus = () => {
    if (Config.TOUCH_ENABLED) {
      elInput.current.focus()
    }
  }
  const onFocusInput = () => { setLock(false); }
  const onClickSearch = () => { onEnterPress({charCode: 13}) }

  return (
    <div id={`ref-search`} tabIndex={0} className={`${className} tab-bar-search search-box ${focus ? `focus` : `nofocus`}`} style={style} onFocus={prepareFocus} onBlur={prepareBlur}>
      <IconSearch className={`icon-search`} onClick={onClickSearch} />
      <div ref={el} className={`search-select ${lock && 'active'}`} onClick={showContextMenu}>
        <div className={`flexRow`}>
          <span className={`grey-1`}>{type}</span>
          { !lock ? <ChevronInactive className={`chevron-search`} /> : <ChevronActive className={`chevron-search`} />  }
        </div>
      </div>
      <div className="search-clear" onClick={clear}>
        { value.length > 0 ? <IconClear size={14} className={`icon-clear`} /> : null }
      </div>
      <input ref={elInput} className={`search-input ${focus ? `focus` : `nofocus`} type-regular`}
        onKeyPress={onEnterPress} name={`search-advanced`} autoComplete={`off`}
        value={value} onChange={onChange} type="text" placeholder={focus ? '' : placeholder}
        onClick={forceFocus} onFocus={onFocusInput}
      />
    </div>
  )
}

ConnectedSearchAdvanced.propTypes = {
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

const SearchAdvanced = connect(
  state => ({
    api: state.api,
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setContextMenu: (items, options) => dispatch(setContextMenu(items, options)),
    setStateShortcuts: state => dispatch(setStateShortcuts(state))
  })
)(ConnectedSearchAdvanced);

export default SearchAdvanced;
